module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('vue-draggable-resizable', {
    key: _vm.handler,
    ref: "cue-handler",
    staticClass: "ql-cue md-card",
    class: [{
      'cue-editing': _vm.isEditing || _vm.isEditingDescription || _vm.isEditingTime,
      'cue-expanded': _vm.expanded,
      'ql-cue--noteslist-linked': _vm.notesListLinked
    }, 'ql-cue-' + _vm.cue.id],
    style: (_vm.styles),
    attrs: {
      "id": _vm.cue.id,
      "handles": [],
      "resizable": false,
      "draggable": _vm.isFloatingCue,
      "disableUserSelect": true,
      "x": _vm.floatingX,
      "y": _vm.floatingY,
      "drag-handle": ".drag"
    },
    on: {
      "dragging": _vm.onDrag,
      "dragstop": _vm.onDragStop
    },
    nativeOn: {
      "mousedown": function($event) {
        return _vm.selectForCopy.apply(null, arguments)
      }
    }
  }, [_c('project-cues-cue-header', {
    ref: "ql-cue-header",
    attrs: {
      "expanded": _vm.expanded,
      "isEditing": _vm.isEditing,
      "isEditingDescription": _vm.isEditingDescription,
      "isEditingTime": _vm.isEditingTime,
      "cue": _vm.cue,
      "layer": _vm.layer,
      "layers": _vm.editableLayers,
      "locked": _vm.locked,
      "editable": _vm.editable,
      "color": _vm.color,
      "selectedScale": _vm.selectedScale,
      "isFloatingCue": _vm.isFloatingCue,
      "focusInputWorkNote": _vm.focusInputWorkNote,
      "svgContentWidth": _vm.svgContentWidth,
      "svgTrueHeight": _vm.svgTrueHeight
    },
    on: {
      "toggle": _vm.toggle,
      "cueUpdated": _vm.updatedCue,
      "updateStatus": _vm.updateStatus,
      "tetherCue": _vm.tetherCue,
      "untetherCue": _vm.untetherCue,
      "focusWorkNote": _vm.focusInputWorkNote
    }
  }), _vm._v(" "), _c('project-cues-cue-body', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expanded),
      expression: "expanded"
    }],
    attrs: {
      "id": 'cue-body-box-attr-' + _vm.cue.id,
      "cue": _vm.cue,
      "locked": _vm.locked,
      "editable": _vm.editable,
      "color": _vm.color,
      "selectedScale": _vm.selectedScale,
      "isFloatingCue": _vm.isFloatingCue,
      "userDefined": _vm.getUserDefined,
      "svgContentWidth": _vm.svgContentWidth,
      "svgTrueHeight": _vm.svgTrueHeight
    },
    on: {
      "toggle": _vm.toggle,
      "cueUpdated": _vm.updatedCue,
      "destroy": _vm.destroy
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-424a90d7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/cues/cue.vue
// module id = 1233
// module chunks = 21